import { useEffect } from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import { getUser } from './restApi';

const ProfileLoader = ({ userId }) => {
  const state = useProfileState();
  const { initializeState, onResponse, onError } = useProfileActions();

  useEffect(() => {
    if (userId) {
      initializeState(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (state.user?.id) {
      getUser({
        id: state.user.id,
        onResponse,
        onError,
      });
    }
  }, [state.user?.id]);

  useEffect(() => {
    if (!!state.user?.firstName && !!state.user?.lastName) {
      document.title = `Isibute | ${state.user.firstName} ${state.user.lastName}`;
    }
  }, [state.user?.firstName, state.user?.lastName]);

  return null;
};

export default ProfileLoader;
